export type MapsLinkImportErrorCode = 'SHORT_LINK' | 'UNRESOLVED' | 'INVALID';

export class MapsLinkImportError extends Error {
  readonly code: MapsLinkImportErrorCode;

  constructor(code: MapsLinkImportErrorCode, message: string) {
    super(message);
    this.name = 'MapsLinkImportError';
    this.code = code;
  }
}

export const SHORT_MAPS_LINK_HELP =
  'Los enlaces cortos (maps.app.goo.gl) no se pueden resolver solo con la clave del navegador. ' +
  'Abre el enlace en una pestaña, copia la URL completa de la barra de direcciones ' +
  '(debe empezar por https://www.google.com/maps/...) y pégala aquí.';

export const UNRESOLVED_MAPS_LINK_HELP =
  'No pudimos leer el lugar de este enlace. Abre el enlace en el navegador, copia la URL completa ' +
  'de la barra de direcciones (google.com/maps/place/...) y pégala aquí.';
